export default "__VITE_ASSET__B367Qo7C__"